import { Preview } from "@creatomate/preview";
import { ElementSource, Organization, Story } from "chq";
import { genericMontageTemplate } from "../../sidebar/tabs/template/implementors/implementors";

export interface ImplementorMontageTemplateParams {
  preview: Preview;
  selectedStories: Story[];
  onStoryUpdate: (story: Story) => void;
  organization: Organization;
  oldSource: ElementSource;
  story?: Story;
  prompt?: string;
}

const setMontageCustomTemplate = async (
  preview: Preview,
  organization: Organization,
  prompt: string | undefined,
  oldSource: ElementSource,
  selectedStories: Story[],
  onStoryUpdate: (story: Story) => void
): Promise<void> => {
  await genericMontageTemplate({
    preview,
    selectedStories,
    onStoryUpdate,
    organization,
    prompt,
    oldSource
  });
};

export default setMontageCustomTemplate;
